import G2FLogo from './G2FLogo';

export default G2FLogo;
